// extracted by mini-css-extract-plugin
module.exports = {"bordered":"FpSelect_bordered__200L8","select_label":"FpSelect_select_label__U2IDu","country_select":"FpSelect_country_select__21InH"};